import { createFileRoute } from '@tanstack/react-router';
import SearchResultsPage from '../components/SearchResultsPage';
import { validateSearchParams } from '../services/search';

export const Route = createFileRoute('/_app/search/read/$id')({
  component: SearchReadPage,
  validateSearch: validateSearchParams,
});

function SearchReadPage() {
  const { q, site, author, sort, page } = Route.useSearch();

  // No onPageChange: the reader view doesn't page the underlying results (the
  // active bookmark id comes from the route). BookmarkListPage picks up the
  // active id from the URL and opens it in the reader column.
  return <SearchResultsPage q={q} site={site} author={author} sort={sort} page={page} />;
}
